import Performance from './utils/performance';

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
      
      // Also report to our performance monitoring
      getCLS(Performance.reportWebVitals);
      getFID(Performance.reportWebVitals);
      getFCP(Performance.reportWebVitals);
      getLCP(Performance.reportWebVitals);
      getTTFB(Performance.reportWebVitals);
    });
  }
};

export default reportWebVitals;
